import { gql } from '@apollo/client';

export const ADD_JS_LOG = /* GraphQL */ `
  mutation AddJsLog($input: JsLogInput) {
    addJsLog(input: $input) {
      code
      message
      content
    }
  }
`;

export const ADD_ANNIVERSARY_PRIZE_DRAW_NUMBER = gql`
  mutation addAnniversaryPrizeDrawNumber($email: String!, $code: String!) {
    addAnniversaryPrizeDrawNumber(input: { email: $email, code: $code }) {
      number
    }
  }
`;

export const ADD_ANNIVERSARY_PRIZE_WON_DATA = gql`
  mutation addAnniversaryPrizeWonData($email: String!) {
    addAnniversaryPrizeWonData(email: $email) {
      code
    }
  }
`;

export const REVOKE_CUSTOMER_TOKEN = gql`
  mutation RevokeCustomerToken {
    revokeCustomerToken {
      result
    }
  }
`;

export const ADD_REPORTS_CLICK_EVENT = gql`
  mutation AddReportsClickEvent($ip: String!, $word: String!, $click_id: Int, $url: String) {
    addReportsClickEvent(ip: $ip, word: $word, click_id: $click_id, url: $url) {
      content
      code
      message
    }
  }
`;

export const ADD_STYLE_IN_FALL_AND_WINTER = /* GraphQL */ `
  mutation addStyleInFallAndWinter($input: StyleInFallAndWinterInput!) {
    addStyleInFallAndWinter(input: $input) {
      content
      code
      message
    }
  }
`;

export const CLEAR_BACKEND_GRAPHQL_CACHE = /* GraphQL */ `
  mutation ClearBackendGraphqlCache($productIds: [Int], $categoryIds: [Int]) {
    clearProductCache(productIds: $productIds, categoryIds: $categoryIds) {
      code
      content
      message
    }
  }
`;

export const ADD_WEDDING_GUIDE = /* GraphQL */ `
  mutation addWeddingGuide($input: WeddingGuideInput) {
    addWeddingGuide(input: $input) {
      code
      content
      message
    }
  }
`;

export const ADD_CHARACTER_CARDS = /* GraphQL */ `
  mutation addCharacterCards($input: CharacterCardsInput) {
    addCharacterCards(input: $input) {
      code
    }
  }
`;

export const ADD_PRODUCT_RECOMMEND = /* GraphQL */ `
  mutation AddProductRecommend($input: ProductRecommendInput) {
    addProductRecommend(input: $input) {
      code
    }
  }
`;
